import type { RefIns } from 'src/components/common/EasyTable'
import React, { useEffect, useMemo, useRef } from 'react'
import { Form, Row, Col, Input, Popconfirm, message, Button } from 'antd'
import { Title, EasyTable, EasyModal, EasyIcon } from 'src/components'
import AuthManage from './AuthManage'
import { $api } from 'src/plugins'
import dayjs from 'dayjs'

const Authorize = (props: { record: any }) => {
  const [form] = Form.useForm()
  useEffect(() => {
    $api['op028/getAppInfoByAdmin']({
      AppId: props.record.ID
    }).then(res => {
      res && form.setFieldsValue(res)
    })
  }, [])

  const localTabel = useRef<RefIns>()
  const getList = (payload: {
    PageIndex: number,
    Limit: number,
  }) => {
    return $api['op028/getInstallTenantExpirations'](
      {
        AppId: props.record.ID,
        PageIndex: payload.PageIndex,
        PageSize: payload.Limit
      },
      { fullData: true }
    )
  }

  const columns = useMemo(() => {
    const handleDel = (record: any) => {
      $api['op028/unInstallAppByAdmin']({
        TenantCode: record.TenantCode,
        AppId: record.AppId,
      }).then(res => {
        if (res) {
          message.success('删除成功')
          localTabel.current?.reload()
        }
      })
    }

    return [
      { title: '序号', render: (text: any, record: any, index: number) => (index + 1) },
      { title: '租户名称', dataIndex: 'TenantName' },
      {
        title: '截至时间',
        dataIndex: 'ExpireTime',
        render: (text: string) => {
          return dayjs(text).format('YYYY-MM-DD')
        }
      },
      {
        title: '操作',
        render: (text: any, record: any) => {
          return (
            <React.Fragment>
              <EasyModal
                modal={{ title: '授权租户编辑', width: 320 }}
                onClose={localTabel.current?.reload}
                slot={
                  <span>
                    <EasyIcon type='EditOutlined' size={16} />
                    <span className='pd-l4'>编辑</span>
                  </span>
                }
                slotClass='mg-r8'
              >
                <AuthManage record={record} />
              </EasyModal>
              <Popconfirm title='确认删除？' onConfirm={() => handleDel(record)}>
                <span className='cursor-pointer color-error'>
                  <EasyIcon type='DeleteOutlined' size={16} />
                  <span className='pd-l4'>删除</span>
                </span>
              </Popconfirm>
            </React.Fragment>
          )
        }
      },
    ]
  }, [])

  return (
    <div className='op028'>
      <Form layout='vertical' form={form} className='mg-b12'>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item name='AppCode' label='应用标识'>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name='AppName' label='应用名称'>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name='AppTypeName' label='应用类型'>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name='Description' label='应用描述'>
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Title title='授权租户' className='mg-b8' />
      <div className='text-right'>
        <EasyModal
          modal={{ title: '授权租户新增', width: 320 }}
          onClose={() => localTabel.current?.reload()}
          slot={<Button type='primary' icon={<EasyIcon type='PlusOutlined' />}>新增</Button>}
          slotClass='mg-b8'
        >
          <AuthManage />
        </EasyModal>
      </div>
      <div className='op028__table'>
        <EasyTable
          onRef={ins => localTabel.current = ins}
          table={{
            rowKey: 'ID',
            columns
          }}
          remoteMethod={getList}
        />
      </div>
    </div>
  )
}

export default Authorize